// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"283":"bd42a7e8","668":"814e3473"}[chunkId] + ".css";
};